import React from "react";
import { createRoot } from "react-dom/client";
import App from "./scenes/App";
import { initialiseSentry, reportErrorToSentry } from "./utils/sentry";
import { Provider } from "react-redux";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import store from "./redux/store";

const theme = createTheme();
initialiseSentry();

createRoot(document.getElementById("root")).render(
    <Provider store={store}>
        <ThemeProvider theme={theme}>
            <App/>
        </ThemeProvider>
    </Provider>
);
